import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FAQS, FAQSQuestions } from 'src/app/model/question-item';
import { MSSPService } from 'src/app/services/mssp.service';

@Component({
  selector: 'app-mas-garantia',
  templateUrl: './mas-garantia.component.html',
  styleUrls: ['./mas-garantia.component.scss']
})
export class MasGarantiaComponent implements OnInit {

  faqs:FAQS | null = null;
  questions: FAQSQuestions [] | undefined = undefined;
  isMobile:boolean = false;
  products:any;
  items:any;

  constructor(
    private breakPointObserver: BreakpointObserver,
    private msspService: MSSPService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    console.log('q', this.route)
    this.breakPoint();
    this.getData();
  }

  breakPoint(){
    this.breakPointObserver.observe([Breakpoints.XSmall]).subscribe( result => {
      if(result.matches){
        this.isMobile = true;
      }else{ 
        this.isMobile = false;
      }
    });
  }

  getData(){
    this.msspService.GetAllDealerCodeByClient('103','FrequentlyAskedQuestions').subscribe( (response) =>{
      const parsefaqs = JSON.parse(response.fullResponse[0].FrequentlyAskedQuestions)
      this.setFAQS(parsefaqs);
      const parseProducts = JSON.parse(response.fullResponse[0].ProductCodeIcon);
      this.getProducts(parseProducts);
    });
  }

  setFAQS(parsefaqs: any){
    this.faqs = parsefaqs.Questions[0];
    this.questions = this.faqs?.Questions;
  }

  getProducts(parseProducts: any){
    this.products = parseProducts;
    this.items = this.products.Articulos[0].Items;
  }

}
